/**
 * The only door in this codebase to Mailchimp.
 *
 * Client wrappers for the `campaignSend` callable
 * (functions/src/handlers/crm/campaignSend.ts). Same shape as
 * crewCardCallables.js. The Mailchimp key lives in Secret Manager and is
 * never in the browser; consent is re-applied on the server every time
 * (CRM v3 plan, security posture 1, 2 and 5).
 *
 * `tools/crm/*` has no equivalent of this file and never will: a script
 * cannot send.
 */
import { callable } from "../firebase.js";

const CALLABLE = "campaignSend";

/* The test seam. The ?e2e=crm fixture has no Firebase, so it installs a stub
   the same way the interactions cache is seeded. App code never touches it. */
let stub = null;

/** @param impl an object with test/schedule/sync, or null to restore the real one. */
export function __setCampaignApi(impl) {
  stub = impl;
}

const run = async (action, payload) => {
  if (stub) return stub[action](payload);
  const fn = callable(CALLABLE, { timeout: 300000 });
  const result = await fn({ action, ...payload });
  return result.data;
};

export const campaignApi = {
  /** Build the HTML, create or update the Mailchimp campaign, send one test.
   *  Returns { mailchimpCampaignId, sentTo }. */
  test: ({ campaignId, to }) => run("test", { campaignId, to }),

  /** Re-check consent, sync the audience, schedule (or send, inside 5 minutes).
   *  Returns { status, mailchimpCampaignId, scheduledFor, sentAt, recipients, dropped }. */
  schedule: ({ campaignId }) => run("schedule", { campaignId }),

  /** Pull the report, write `results`, write one campaign_touch per recipient.
   *  Returns { status, results, touches }. */
  sync: ({ campaignId }) => run("sync", { campaignId }),
};

export default campaignApi;
